
import { Component, Vue } from "vue-property-decorator";

import PICTURE_1 from "@/pages/Auth/assets/bg-top-right.svg";
import PICTURE_2 from "@/pages/Auth/assets/bg-bottom-left.svg";

@Component
export default class Auth extends Vue {
  PICTURE_1 = PICTURE_1;
  PICTURE_2 = PICTURE_2;
}
